import { OtherContent } from '@/domain/entities/OtherContent'
import { AxiosResponse } from 'axios'
import { BaseResponseMapper } from './Base'

export class OtherContentDataMapper extends BaseResponseMapper {
  public convertOtherContentFromApi(result: AxiosResponse<any>): OtherContent {
    const { data } = result
    return new OtherContent(data.success, data.message, data.data)
  }
}
